import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dispatch } from '@ro-store';
import { withRouter } from 'react-router-dom';
import { tutorials } from './utils';
import { Steps } from 'intro.js-react';

import { translate } from 'react-i18next';

class Tutorial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stepsEnabled: true,
      initialStep: 0
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userSettings.tutorialLevel !== this.props.userSettings.tutorialLevel) {
      this.setState({
        stepsEnabled: true
      });
    }
  }

  onExit = () => {
    this.setState({
      stepsEnabled: false
    });
    dispatch.ro.setTutorialLevel(false);
  };

  menuStepButtonEvent = e => {
    const tutorial = tutorials[this.props.name];
    if (e.target.closest(`#${tutorial.buttonId}`)) {
      this.setState({
        stepsEnabled: false
      });

      if (tutorial.actionNext) {
        this.props.history.push(tutorial.actionNext);
        dispatch.ro.setTutorialLevel(tutorial.nextTutorialLevel);
      } else {
        this.props.actionNext().then(() => dispatch.ro.setTutorialLevel(tutorial.nextTutorialLevel));
      }
    }
  };

  setInsideActions = () => {
    document.addEventListener('click', this.menuStepButtonEvent);
  };

  render() {
    const { userSettings } = this.props;

    const { stepsEnabled, initialStep } = this.state;

    const tutorial = tutorials[this.props.name];
    document.removeEventListener('click', this.menuStepButtonEvent);

    return tutorial && this.props.tutorialStarted && userSettings.tutorialLevel === tutorial.index ? (
      <Steps
        enabled={stepsEnabled}
        onExit={this.onExit}
        steps={tutorial.steps()}
        initialStep={initialStep}
        onBeforeChange={this.setInsideActions}
        options={{
          showBullets: false,
          showStepNumbers: false,
          exitOnOverlayClick: false,
          nextLabel: 'Dalej',
          prevLabel: 'Wstecz',
          skipLabel: 'Wyjdź',
          doneLabel: 'Wyjdź',
          keyboardNavigation: false,
          hideNext: true,
          disableInteraction: true
        }}
      />
    ) : null;
  }
}
const mapStateToProps = ({ ro }) => ro;
export default withRouter(connect(mapStateToProps)(translate('common')(Tutorial)));
